import { fetchApiRaw } from 'r/utils/fetchApiRaw';
import captureException from './captureException';
import { StoredAuth } from 'r/utils/Stored';

interface ApiResponse<T> {
  data: T[];
  total: number;
}

interface FetchAllDataResult<T> {
  data: T[];
  total: number;
}

const batchSize = 500;
export default async function fetchAllData<T>(
  endpoint: string,
  params: {
    noAuth?: boolean;
    total?: number;
    queryParams?: Record<string, unknown>;
  } = {},
): Promise<FetchAllDataResult<T>> {
  try {
    const accessToken = StoredAuth.get();

    const firstResponse: ApiResponse<T> = await fetchApiRaw(
      endpoint,
      {
        queryParams: {
          ...params.queryParams,
          skip: 0,
          take: batchSize,
        },
      },
      params.noAuth ? undefined : accessToken,
    );

    const allData: T[] = firstResponse.data;
    const total = params.total ?? firstResponse.total;
    for (let skip = batchSize; skip < total; skip += batchSize) {
      const response = (await fetchApiRaw(
        endpoint,
        {
          queryParams: {
            ...params.queryParams,
            skip,
            take: batchSize,
          },
        },
        params.noAuth ? undefined : accessToken,
      )) as ApiResponse<T>;
      allData.push(...response.data);
    }

    return { data: allData, total };
  } catch (error) {
    captureException(error);
    throw error;
  }
}
